import { useTranslation } from 'react-i18next'

export const useVariantsConfig = () => {
  const { t } = useTranslation()

  return {
    ton_wallet: {
      connected: {
        iconName: 'wallet_connect',
        title: t('info_container.ton_wallet.connected'),
        subtitle: t('info_container.ton_wallet.wallet_is_connected'),
        buttonText: t('info_container.ton_wallet.turn_off_question'),
        buttonColor: 'orange',
        buttonOpacity: true,
      },
      not_connected: {
        iconName: 'wallet_not_connect',
        title: t('info_container.ton_wallet.not_connected'),
        subtitle: t('info_container.ton_wallet.not_connected'),
        buttonText: t('info_container.ton_wallet.connect'),
        buttonColor: 'violet',
        buttonOpacity: false,
      },
    },
    support: {
      iconName: 'support-large',
      title: t('info_container.support.need_help_question'),
      subtitle: t('info_container.support.contact_our_bot'),
      buttonText: t('info_container.support.write_bot'),
      buttonColor: 'violet',
      buttonOpacity: false,
    },
    go_out: {
      iconName: 'go_out',
      title: t('info_container.go_out.want_exit_question'),
      subtitle: t('info_container.go_out.you_can_sign_in_again'),
      buttonText: t('info_container.go_out.log_out_of_account'),
      buttonColor: 'orange',
      buttonOpacity: true,
    },
  }
}
